import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, Heart, ArrowLeft } from 'lucide-react';

export default function DonateCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4" data-testid="donate-cancel-page">
      <Card className="max-w-md w-full p-8 text-center glass-card border-border">
        <div className="w-20 h-20 rounded-full bg-yellow-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-yellow-500" />
        </div>
        
        <h1 className="text-2xl font-bold mb-2">Donation Cancelled</h1>
        <p className="text-muted-foreground mb-6">
          No worries! Your support means a lot, even if it's just spreading the word about DMV Soundstage.
        </p>
        
        <div className="flex flex-col gap-3">
          <Button onClick={() => navigate('/')} variant="outline" data-testid="donate-go-back">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
          <Button onClick={() => navigate('/donate')} className="bg-red-500/20 hover:bg-red-500/30 text-red-400">
            <Heart className="w-4 h-4 mr-2" />
            Try Again
          </Button>
        </div>
      </Card>
    </div>
  );
}
